import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { pure } from '@dbk/ui-react-utils';

import styles from './calendar.styles';

function CalendarWeekSelectionGlow(props) {
  const { selectionData } = props;
  let index = 0;
  let leftCount = 0;
  let middleCount = 0;
  let rightCount = 0;

  for (; index < 7 && !selectionData[index]; ++index) {
    leftCount++;
  }

  for (; index < 7 && selectionData[index]; ++index) {
    middleCount++;
  }

  for (; index < 7 && !selectionData[index]; ++index) {
    rightCount++;
  }

  if (middleCount === 0) {
    return null;
  }

  return (<View
    style={styles.calendarWeekGlowWrapper}
  >
    <View style={{ flex: leftCount }} />
    <View style={[styles.calendarWeekGlow, { flex: middleCount }]} />
    <View style={{ flex: rightCount }} />
  </View>);
}

CalendarWeekSelectionGlow.propTypes = {
  selectionData: PropTypes.arrayOf(PropTypes.bool),
};

export default pure(CalendarWeekSelectionGlow);
